import { RealTimeServiceContext } from 'contexts/realTimeService';
import { useContext, useMemo } from 'react';
import type { TIssuedRewards } from '../helpers/rewardBonus';
import { getIssuedRewards } from '../helpers/rewardBonus';
import { useCycle } from './useCycle';

export const useIssuedRewards = (): TIssuedRewards => {
  const { bonuses, freespins, lootboxes } = useContext(RealTimeServiceContext);
  const { start } = useCycle();

  return useMemo(
    () => getIssuedRewards([...bonuses, ...freespins, ...lootboxes], start),
    [bonuses, freespins, lootboxes, start]
  );
};
